/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  #bg {
    fill: #fff;
  }
  #outline, #arrow {
    fill: ${theme.color.mainBg};
  }
`
export default class NavRefreshIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" css={Color}>
        <g id="그룹_7182" data-name="그룹 7182" transform="translate(1077 -4426)">
          <circle id="bg" cx="6" cy="6" r="6" transform="translate(-1075 4428)" fill="#fff"/>
          <path id="outline" d="M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0M6-2A8,8,0,1,1-2,6,8.009,8.009,0,0,1,6-2Z" transform="translate(-1075 4428)" fill="#1c202b"/>
          <path id="arrow" d="M2.468,7.149A3.527,3.527,0,0,1,.317,5.512a.58.58,0,0,1,.21-.792l.007,0A.572.572,0,0,1,.818,4.64a.579.579,0,0,1,.5.289,2.365,2.365,0,0,0,3.244.853l.017-.012a2.372,2.372,0,0,0-2.4-4.091,2.337,2.337,0,0,0-.507.4L2.7,2.062l.011,0a.543.543,0,0,1,0,1.086L.591,3.2a.545.545,0,0,1-.543-.532L0,.555A.542.542,0,0,1,.531,0H.544L.555,0a.554.554,0,0,1,.533.529l.012.533A3.075,3.075,0,0,1,1.6.693,3.525,3.525,0,0,1,5.2,6.754l-.159.09a3.509,3.509,0,0,1-2.572.305Z" transform="translate(-1072.35 4430.45)" fill="#1c202b"/>
        </g>
      </svg>
    )
  }
}
